import React, {useEffect, useState} from "react";
import { Route, Redirect } from "react-router-dom";
import isLogin from "../utils/isLogin";

const PublicRoute = ({component: Component, restricted, ...rest}) => {
    const [isResponseSuccess, setIsResponseSuccess] = useState(false);
    const [isTmpCont, setIsTmpCont] = useState(false);
    const [isLoginSuccess, setIsLoginSuccess] = useState(false);

    useEffect(() => {
        if (rest.path !== "/") {
            isLogin().then((res) => {
                // console.log("isLogin public page : ", res);
                setIsLoginSuccess(res.isAuth);
                setIsTmpCont(res.isTmpCont);
                setIsResponseSuccess(true);
            });
        } else {
            setIsResponseSuccess(true);
        }
    }, [isLoginSuccess]);

    return (
        isResponseSuccess && (
            <Route {...rest} render={props => (
                isLoginSuccess && restricted ?
                    <Redirect to="/agree" />
                    : <Component login={isLoginSuccess} isTmpCont={isTmpCont} {...props} />
            )} />
        )
    );
};

export default PublicRoute;
